<template>
  <div>
    <!-- Backdrop overlay pour mobile -->
    <div 
      v-if="$sidebar.showSidebar" 
      class="sidebar-backdrop"
      @click="closeMenu"
    ></div>
    
    <div
      class="sidebar"
      :data-background-color="backgroundColor"
      :data-active-color="activeColor"
    >
      <!--
              Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
              Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
          -->
      <!-- -->
      <div class="sidebar-wrapper" id="style-3">
        <div class="logo">
          <a href="#" aria-label="Patrimonea">
            <div class="logo-img">
              <img :src="logoImg" alt="Patrimonea" class="sidebar-logo-img" />
            </div>
          </a>
        </div>
        <slot> </slot>
        <ul class="nav">
          <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
          <slot name="links">
            <sidebar-link
              v-for="(link, index) in sidebarLinks"
              :key="index"
              :to="link.path"
              :name="link.name"
              :icon="link.icon"
            >
            </sidebar-link>
          </slot>
        </ul>
        <moving-arrow :move-y="arrowMovePx"> </moving-arrow>
      </div>
    </div>
  </div>
</template>
<script>
import MovingArrow from "./MovingArrow.vue";
import SidebarLink from "./SidebarLink";
import logoImg from "@/assets/logo.png";
export default {
  props: {
    title: {
      type: String,
      default: "Patrimonea",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["white", "black", "darkblue"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
      addLink: this.addLink,
      removeLink: this.removeLink,
    };
  },
  components: {
    MovingArrow,
    SidebarLink,
  },
  computed: {
    displayTitle() {
      return this.title ? this.title.replace(/é/g, 'e') : this.title;
    },
    /**
     * Styles to animate the arrow near the current active sidebar link
     * @returns {{transform: string}}
     */
    arrowMovePx() {
      return this.linkHeight * this.activeLinkIndex;
    },
  },
  data() {
    return {
      linkHeight: 65,
      activeLinkIndex: 0,
      windowWidth: 0,
      isWindows: false,
      hasAutoHeight: false,
      links: [],
      logoImg,
    };
  },
  methods: {
    findActiveLink() {
      this.links.forEach((link, index) => {
        if (link.isActive()) {
          this.activeLinkIndex = index;
        }
      });
    },
    addLink(link) {
      const slotLinks = typeof this.$slots.links === "function"
        ? this.$slots.links()
        : this.$slots.links;

      if (!Array.isArray(slotLinks)) {
        this.links.push(link);
        return;
      }

      const index = slotLinks.indexOf(link.$vnode);
      if (index === -1) {
        this.links.push(link);
        return;
      }

      this.links.splice(index, 0, link);
    },
    removeLink(link) {
      const index = this.links.indexOf(link);
      if (index > -1) {
        this.links.splice(index, 1);
      }
    },
    closeMenu() {
      if (this.$sidebar && this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  mounted() {
    this.$watch("$route", this.findActiveLink, {
      immediate: true,
    });
  },
};
</script>
<style scoped>
/* Backdrop overlay moderne pour mobile */
.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 1499;
  animation: fadeIn 0.3s ease;
  display: none;
}

@media (max-width: 991px) {
  .sidebar-backdrop {
    display: block;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wrapper .sidebar .logo-img {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: none;
  border-radius: 8px;
  padding: 6px;
}
.sidebar-logo-img {
  width: 100%;
  height: auto;
  object-fit: contain;
  clip-path: none;
}

@media (max-width: 576px) {
  .logo-img {
width: 100%;
    padding: 0;
  }
  
  .sidebar-logo-img {
    max-height: 220px;
  }
}

@media (max-width: 400px) {
  .logo-img {
    width: 100%;
    padding: 0;
  }
  
  .sidebar-logo-img {
    max-height: 200px;
  }
}
</style>
